import * as MapView from "./lib/ClusteredMapView";
module.exports = MapView;
